import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import { CarouselProvider } from '$contexts/carousel';
import Carousel, { CarouselNavigation, CarouselSlide } from '$partials/ui/carousel';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleCarousel = ({
    images = {}
}) => {
    return (
        <div className='my-44 md:my-70 overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2'>
            <CarouselProvider>
                <div className='z-10 hidden md:flex relative layout-container pl-0'>
                    <div className='w-full'>
                        <CarouselNavigation className='swiper-navigation'/>
                    </div>
                </div>
                <Carousel className='flex swiper-wrapper h-auto w-full md:mt-[-45px] image-carousel'>
                    {images.items.map((item, idx) => {
                        return (
                            <CarouselSlide
                                className='h-auto flex flex-wrap image-carousel-slide px-10 sm:px-20'
                                index={idx}
                                key={`${item.image?.id}-journal-item-${idx}`}>
                                <Image
                                    loadWidth={565}
                                    {...item.image} />
                                {!!item.caption &&
                                    <figcaption className='w-full type-style-7 text-dark-grey whitespace-pre-wrap mt-15'>
                                        {item.caption}
                                    </figcaption>
                                }
                            </CarouselSlide>
                        );
                    })}
                </Carousel>
            </CarouselProvider>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleCarousel.propTypes = {
    images: PropTypes.shape({
        items: PropTypes.array,
    }),
};

export default ModuleCarousel;
